<!--  -->
<template>
  <div class="wechat_box">
    <div style="width:430px">
      <el-form
        :label-position="labelPosition"
        label-width="100px"
        :model="formLabelAlign"
      >
        <el-form-item label="小程序标题">
          <el-input
            v-model="formLabelAlign.title"
            style="width:400px"
          />
        </el-form-item>
        <el-form-item label="小程序类型">
          <el-select
            v-model="formLabelAlign.formLabeltype"
            placeholder="请选择"
            @change="chawer"
            style="width:400px"
          >
            <el-option
              v-for="items in programtype"
              :key="items.mini_program_type"
              :label="items.type_name"
              :value="items.mini_program_type"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formLabelAlign.formLabeltype === 9999"
          label="小程序appid"
        >
          <el-tag
            v-if="formLabelAlign.appid"
            class="appid_box"
          >{{ wechatname }}</el-tag>
          <el-button
            type="primary"
            size="mini"
            @click="chooseapplet"
          >选择小程序</el-button>
        </el-form-item>
        <el-form-item label="跳转地址">
          <el-input
            v-model="formLabelAlign.link"
            style="width:400px"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="sumitsr"
          >确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      v-if="formLabelAlign.formLabeltype === 9999"
      class="wecahrt_link"
    >
      <div class="wechan_linktitle">小程序指定路径</div>
      <el-table
        :data="programtypelist"
        border
        style="width: 100%;"
      >
        <el-table-column
          prop="type_name"
          label="小程序名称"
          width="170"
          align="center"
        />
        <el-table-column
          prop="index_path"
          label="路径"
          width="250"
          align="center"
        />
        <el-table-column
          prop="index_path"
          label="操作"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="choose(scope.row.index_path)"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="30%"
    >
      <chhosewechat
        ref="chhosewecahtr"
        @callback="callback"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mptypeslist } from '@/api/sourceMaterial.js'
import chhosewechat from '../../wechatbinding/components/chhosewechat.vue'
export default {
  components: { chhosewechat },
  data() {
    return {
      labelPosition: 'right',
      dialogVisiblewechat: false,
      programtype: [],
      programtypelist: [],
      formLabelAlign: {
        title: '',
        link: '',
        formLabeltype: null,
        appid: null
      },
      wechatname: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    send() {
      this.getmptypeslist()
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = this.deepCopy(data.data.types)
      this.programtypelist = this.deepCopy(data.data.types)
      this.programtype.push({
        type_name: '指定小程序',
        mini_program_type: 9999
      })
      console.log('data', data.data.types)
    },
    deepCopy(obj, cache = []) {
      // 如果为普通数据类型，则直接返回，完成拷贝
      if (obj === null || typeof obj !== 'object') {
        return obj
      }
      // cache用来储存原始值和对应拷贝数据，在递归调用deepCopy函数时，如果本次拷贝的原始值在之前已经拷贝了，则直接返回储存中的copy值，这样的话就不用再循环复制本次原始值里面的每一项了。
      // 还有一个更为重要的作用，假如原始值里面嵌套两个引用地址相同的对象，使用cache可以保证拷贝出来的copy值里面两个对象的引用地址也相同。
      // 如果find查找的是一个空数组，则不会执行
      const hit = find(cache, c => c.original === obj)
      if (hit) {
        return hit.copy
      }
      // 定义拷贝的数据类型
      const copy = Array.isArray(obj) ? [] : {}
      // 用来记录拷贝的原始值和copy值
      cache.push[
        {
          original: obj,
          copy
        }
      ]
      // 递归调用深拷贝函数，拷贝对象中的每一个值
      Object.keys(obj).forEach(key => {
        copy[key] = this.deepCopy(obj[key], cache)
      })
      return copy
    },
    chawer(val) {
      console.log('val', val)
      if (val === 9999) {
        console.log('9999')
      } else {
        this.formLabelAlign.appid = null
        this.wechatname = ''
        console.log('2222')
      }
      // eslint-disable-next-line eqeqeq
      const index = this.programtype.findIndex(v => v.mini_program_type == val)
      this.formLabelAlign.link = this.programtype[index].index_path
    },
    sumitsr() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.title == '') {
        this.$message.error('请输入标题')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.formLabeltype == null) {
        this.$message.error('请选择小程序类型')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.formLabeltype == 9999) {
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.appid == null) {
          this.$message.error('请选择小程序')
          return
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.link == '') {
        this.$message.error('请输入跳转地址')
        return
      }
      console.log('this.formLabelAlign', this.formLabelAlign)
      this.$emit('appletscallback', this.formLabelAlign)
    },
    chooseapplet() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.formLabelAlign.appid = item.app_id
      console.log('item', item)
    },
    choose(clink) {
      this.formLabelAlign.link = clink
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.appid_box {
  margin-right: 10px;
}
.wechat_box {
  display: flex;
  justify-content: space-between;
}
.wecahrt_link {
  text-align: center;
  margin-left: 60px;
}
.wechan_linktitle {
  margin-bottom: 10px;
}
</style>
